"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymousPricingTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const pricing_data_transport_1 = require("./pricing-data-transport");
const pricing_transport_1 = require("./pricing-transport");
exports.AnonymousPricingTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    serviceAreas: typebox_1.Type.Array(typebox_1.Type.Object({
        id: typebox_1.Type.String(),
        serviceArea: typebox_1.Type.String(),
        areaName: typebox_1.Type.Optional(typebox_1.Type.String()),
        taxJurisdiction: typebox_1.Type.Optional(typebox_1.Type.String()),
    })),
    pricingData: typebox_1.Type.Array(pricing_data_transport_1.MaterialPricingTransport),
    prohibitedItems: typebox_1.Type.Array(typebox_1.Type.String()),
    state: typebox_1.Type.String(),
    tripCharge: typebox_1.Type.Optional(typebox_1.Type.Number()),
    tripChargeDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
    days: typebox_1.Type.Optional(typebox_1.Type.Object({
        mon: typebox_1.Type.Boolean(),
        tue: typebox_1.Type.Boolean(),
        wed: typebox_1.Type.Boolean(),
        thu: typebox_1.Type.Boolean(),
        fri: typebox_1.Type.Boolean(),
        sat: typebox_1.Type.Boolean(),
        sun: typebox_1.Type.Boolean(),
    })),
    rentalPeriod: typebox_1.Type.Optional(typebox_1.Type.Object({
        value: typebox_1.Type.Number(),
        unit: typebox_1.Type.String(),
    })),
    rentExtensionFee: typebox_1.Type.Optional(typebox_1.Type.Number()),
    rentExtensionFeeDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    pricingCalculationVersion: typebox_1.Type.Optional(typebox_1.Type.String()),
    public: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    maxRentalDaysAllowed: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    prePaidRentalDaysDiscountRate: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    allowForPrePaidRentalDays: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    onlineCheckoutPageGuarantee: typebox_1.Type.Optional(typebox_1.Type.String()),
    currentGrowthStage: typebox_1.Type.Optional(pricing_transport_1.PricingGrowthStage),
    actualTaxRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
//# sourceMappingURL=anonymous-pricing-transport.js.map